var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "meet-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.2706385,0 C15.791306,0 -7.10542736e-15,15.6365276 -7.10542736e-15,34.9255955 C-7.10542736e-15,54.2146634 15.791306,69.8514713 35.2706385,69.8514713 L35.3454984,83 C53.468236,72.5541606 70.7037037,58.6107727 70.7037037,34.9255955 C70.7037037,15.6368078 54.749971,0 35.2706385,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-28.6%",
    y: "-42.9%",
    width: "157.1%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "meet-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2706385,0 C15.791306,0 -7.10542736e-15,15.6365276 -7.10542736e-15,34.9255955 C-7.10542736e-15,54.2146634 15.791306,69.8514713 35.2706385,69.8514713 L35.3454984,83 C53.468236,72.5541606 70.7037037,58.6107727 70.7037037,34.9255955 C70.7037037,15.6368078 54.749971,0 35.2706385,0 Z",
    id: "IconifyId-1710defbc04-79ece5-2327",
    fill: "#0F9083",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "IconifyId-1710defbc04-79ece5-2327-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "IconifyId-1710defbc04-79ece5-2327",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8518519,47 C28.2435205,44.7135404 37.9101871,41.7135404 43.8518519,38 C49.7935166,34.2864596 54.1268499,29.2864596 56.8518519,23 L74.8518519,42 L48.8518519,81 L14.8518519,47 Z",
    id: "Rectangle",
    fill: "#078377",
    opacity: 0.75,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter-3)",
    transform: "translate(14.851852, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IconifyId-1710defbc04-79ece5-2329-link",
    transform: "translate(0.000000, 13.000000)",
    fill: "#F6F6F6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.24344979e-14,-1.66533454e-15 L-1.24344979e-14,9.81779919 C-1.24344979e-14,12.4096707 2.03934982,14.5304231 4.53173531,14.5304231 L27.9737803,14.5304231 C30.4661657,14.5304231 32.5052398,12.4096707 32.5052398,9.81779919 L32.5052398,3.61755176 L42,13.2693267 L42,-1.66533454e-15 L-1.24344979e-14,-1.66533454e-15 Z",
    id: "IconifyId-1710defbc04-79ece5-2329"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42,12.9997435 L42,1.09468553 L32.6712858,9.71132556 L32.6712858,4.21609141 C32.6712858,1.89716417 30.6217955,0 28.1166782,0 L4.55488469,0 C2.04949025,0 0,1.89716417 0,4.21634796 L0,13 L42,13 L42,12.9997435 Z",
    id: "Path",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetIcon);
export default __webpack_public_path__ + "static/media/meet-icon.454d7ee49a931f44ab803905e6c31d8c.svg";
export { ForwardRef as ReactComponent };